import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'page-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingPage implements OnInit {

  constructor() {
  }

  ngOnInit() {
      document.getElementsByTagName('body')[0].style.overflow='initial';
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/landing/landing.component.ts